<template>

 <v-container grid-list-md text-xs-center fill-height>
    <v-layout row wrap>
      <v-flex xs6 class="mt-5">
    <img alt="warning"
         src="@/assets/error.png"
         height="330px" />
    <h1 class="mt-3 mb-3"> Opps! 出了點 {{error.error.response.status}} 錯誤!</h1>
    <v-btn outline
           @click="backHandler">回首頁
      <v-icon dark
              right>home</v-icon>
    </v-btn>
      </v-flex>
      <v-flex xs6>
          <code class="mt-5 text-xs-left">
      {{error}}
    </code>
      </v-flex>
    </v-layout>
 </v-container>
</template>
<script>
import router from '@/router'
export default {
  props: {
    error: Object
  },
  data () {
    return {
      // status code
      SC: Object.freeze({
        _400: 400,
        _404: 404,
        _500: 500,
        _515: 515
      })
    }
  },

  created () {
    const $htmlScroll = document.documentElement
    $htmlScroll.className = ''
  },

  methods: {
    backHandler () {
      this.$router.back()
    }
  },

  beforeRouteEnter: (to, from, next) => {
    const error = to.params.error
    if (!error) {
      router.goHome()
    } else {
      next()
    }
  }
}
</script>
<style lang="stylus" scoped>
code
  background-color: #191818;
  color: #e6d7d8;
  font-size: 14px;
  padding:10px;
  width:100%;
  min-height: 500px;
</style>
